import { render, staticRenderFns } from "./ProjectCreatedListPage.vue?vue&type=template&id=2f89d990"
import script from "./ProjectCreatedListPage.vue?vue&type=script&lang=ts"
export * from "./ProjectCreatedListPage.vue?vue&type=script&lang=ts"
import style0 from "./ProjectCreatedListPage.vue?vue&type=style&index=0&id=2f89d990&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports